import { render, staticRenderFns } from "./SearchDropdown.vue?vue&type=template&id=6ac45a45&scoped=true&"
import script from "./SearchDropdown.vue?vue&type=script&lang=js&"
export * from "./SearchDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SearchDropdown.vue?vue&type=style&index=0&id=6ac45a45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac45a45",
  null
  
)

export default component.exports